import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'auth' })
class Auth extends VuexModule {
  token?: string | null
  redirectLoginWithLine: string = ''
  shouldUpdatePassword: boolean = false

  @Mutation
  setNewToken(newToken: string) {
    this.token = newToken
  }

  @Mutation
  setTokenNull() {
    this.token = null
  }

  @Mutation
  setRedirectLoginInWithLine(url: string) {
    this.redirectLoginWithLine = url
  }

  @Mutation
  setShouldUpdatePassword(value: boolean) {
    this.shouldUpdatePassword = value
  }

  @Action
  SET_NEW_TOKEN(newToken: string) {
    this.context.commit('setNewToken', newToken)
  }

  @Action
  SET_TOKEN_NULL() {
    this.context.commit('setTokenNull')
  }

  @Action
  SET_REDIRECT_LOGIN_WITH_LINE(url: string) {
    this.context.commit('setRedirectLoginInWithLine', url)
  }

  @Action
  SET_SHOULD_UPDATE_PASSWORD(value: boolean) {
    this.context.commit('setShouldUpdatePassword', value)
  }
}

export default Auth